import * as React from 'react';
import { IImageEditorFirm } from '../Entities';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import DeleteButton from '../../../components/common/DeleteButton';
import Chip from '@mui/material/Chip';

interface IImageEditorFirmsListRowProps {
    imageEditorFirm: IImageEditorFirm;
    onClickEdit: (id: number) => void;
    discontinued: (id: number, isDiscontinued: number) => void;
}

const ImageEditorFirmsListRow = (props: IImageEditorFirmsListRowProps) => {
    let { imageEditorFirm } = props;
    let isDefault = imageEditorFirm.brokerFirmDefault;
    let isExpress = imageEditorFirm.brokerFirmDefaultExpress;

    return (
        <tr>
            <td>
                {props.imageEditorFirm.name}
                {isDefault === true && (
                    <Chip
                        label={'Default'}
                        color={'primary'}
                        sx={{ fontSize: '1.3rem', marginLeft: '10px' }}
                    />
                )}
                {isExpress === true && (
                    <Chip
                        label={'Express'}
                        color={'primary'}
                        sx={{ fontSize: '1.3rem', marginLeft: '10px' }}
                    />
                )}
            </td>
            <td>
                <i className="material-icons">
                    {props.imageEditorFirm.isDiscontinued ? 'done' : ''}
                </i>
            </td>
            <td>
                <ButtonToolbar className="pull-right btn-group-sm">
                    {props.imageEditorFirm.isDiscontinued ? (
                        <Button
                            onClick={() => props.discontinued(props.imageEditorFirm.id, 0)}
                            bsSize="small"
                            bsStyle="primary"
                        >
                            <i className="material-icons">edit</i>
                            {Translate('image-editor-firms/list/row/button-label/reset')}
                        </Button>
                    ) : (
                        <DeleteButton
                            disabled={
                                props.imageEditorFirm.brokerFirmDefault ||
                                props.imageEditorFirm.brokerFirmDefaultExpress
                            }
                            onDelete={() => props.discontinued(props.imageEditorFirm.id, 1)}
                            text={Translate(
                                'image-editor-firms/list/row/delete/remove-this-image-editor-firm'
                            )}
                        >
                            <i className="material-icons">delete</i>{' '}
                            {Translate('image-editor-firms/list/row/button-label/delete')}
                        </DeleteButton>
                    )}
                    <Button
                        disabled={props.imageEditorFirm.isDiscontinued}
                        className="pull-right"
                        onClick={() => props.onClickEdit(props.imageEditorFirm.id)}
                        bsSize="small"
                        bsStyle="primary"
                    >
                        <i className="material-icons">edit</i>
                        {Translate('image-editor-firms/list/row/button-label/edit')}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default ImageEditorFirmsListRow;
